export default __webpack_public_path__ + "static/media/angpao-bg-mobile.0543b9fa.jpg";